import { Badge } from "@/components/ui/badge";
import { MapPinOff } from "lucide-react";

// Read-only nudge: an AVAILABLE part with no bin (current_location_id=null) hasn't
// been put away yet. Surfaces the fact before staff hit the add-to-cart block.
export const NeedsPutawayBadge = ({ part, className = "" }) => {
  const isAvailable = part?.available ?? part?.status === "available";
  if (!isAvailable || part?.location) return null;
  return (
    <Badge
      data-testid={`needs-putaway-badge-${part.short_code}`}
      title="Available but not put away yet — put it in a bin (Put Away) before adding it to a cart."
      className={`rounded-lg text-[9px] uppercase font-mono w-fit inline-flex items-center gap-1 bg-[#E0781A] text-white border-0 ${className}`}
    >
      <MapPinOff className="w-2.5 h-2.5" />Needs Put Away
    </Badge>
  );
};
